<template>
	<div class='route_container'>
		<!-- Hero section -->
		<div v-if="giveaway" class="bg-gradient py-5 px-5 mt-5 hero_section">			
			<a v-if="giveaway.game_seo" :href="`https://${$store.state.meta.lang}.idcgames.com/${giveaway.game_seo}`" class="hero_section__img_link big-card" target="_blank">
				<div class="img-container">
					<div class="col overflow-hidden px-0">
						<div class="overlay">
							<img :src="giveaway.game_logo" class="logo-overlay card-img-overlay d-flex align-items-center img-fluid m-auto" alt="--">
						</div>
						<div class="overflow-hidden logo-img-container">
							<img class="gameCard-img" :src="giveaway.game_banner" alt="...">
						</div>
					</div>
				</div>
			</a>
			<a v-else href="javascript:void(0)" class="hero_section__img_link big-card">
				<div class="img-container-initComments"></div>
			</a>
			<div class="hero_section__summary py-3 px-3">
				<div class='col-12' key='loading' v-if="loading">
					<thread-display-placeholder></thread-display-placeholder>
				</div>
				<div class="col-12" v-else>
					<h2 class="mb-2"> {{giveaway && giveaway.game_name}} ({{giveaway && giveaway.point}} p) </h2>
					<div class="summary_columns">
						<div class="summary__column">
							<info-tooltip v-if="giveaway.status=='open'">
								<template slot='content'>
									<span><font-awesome-icon class="info_icon" :icon="['fa','clock']" /> 
										{{ giveaway.end_date | localTime }}
									</span>
								</template>
								<div slot='display' class="justify-content-center d-flex align-items-center m-auto">
									<font-awesome-icon :icon='["fa","clock"]' class="mr-1"/> 
									{{ giveaway.end_date | localTime | formatDate(1)  }} {{ $t('gifts_remaining') }}
								</div>
							</info-tooltip>
							<info-tooltip v-else>
								<template slot='content'>
									<span>
										<font-awesome-icon class="info_icon" :icon="['fa','gift']" /> 
										{{ giveaway.end_date | localTime | formatDate  }} {{ $t('gifts_ago') }} ended !									
									</span>
								</template>
								<div slot='display' class="justify-content-center d-flex align-items-center m-auto"> 
									<font-awesome-icon :icon='["fa","gift"]' class="mr-1"/> 
									<span class="mr-1">Giveaway Closed!</span>
									<span v-if="giveaway.winner && giveaway.winner.length">
										Awarded to 
										<router-link v-for="(person, $index) in giveaway.winner" 
													class="mr-1" style="color: #0de274"
													:to="`/${$store.state.meta.lang}/user/${person}`" :key="$index"> 
											{{ person }} 
											<span v-if="giveaway.winner.length > $index+1">, </span>
										</router-link>
									</span>
								</div>
							</info-tooltip>
						</div>
						<div class="summary__column text-right">
							<info-tooltip class="d-inline-flex">
								<template slot='content'>
									<span>
										<font-awesome-icon class="info_icon" :icon="['fa','clock']" /> 
										{{giveaway.start_date | localTime}}
									</span>
								</template>
								<div slot='display'> 
									{{ giveaway.start_date | localTime | formatDate}} {{ $t('gifts_ago') }}									
								</div>
							</info-tooltip>
							<span class="mx-1">{{ $t('gifts_by') }}</span>						
							<router-link :to="`/${$store.state.meta.lang}/user/${giveaway.creator}`"> {{giveaway.creator}} </router-link>
						</div>
						<div class="giveaway__columns__contributor-level"> {{ $t('gifts_level') }} {{ giveaway && giveaway.contribute_level }} + </div>
						<router-link 
							:to="`/${$store.state.meta.lang}/user/${giveaway.creator}`" 
							class="giveaway_image_avatar" 
							:style="giveaway.profile_photo_path?
							{ 'background-image': 'url(' + apiDomain + '/uploads/avatar/'+ giveaway.profile_photo_path + ')' }:
							{ 'background-image': 'url(' + missed_avatar + ')' }">
						</router-link>
					</div>
				</div>				
			</div>
		</div>
		<div class="main_container px-5 py-3">
			<div class="row">
				<!-- category sidebar -->
				<div class="col-lg-3 filter-column pr-lg-3 px-0 py-3">
					<div v-if="giveaway.status=='open' && $store.state.level >= giveaway.contribute_level">
						<div class="row text-center mb-3 d-flex justify-content-center"
							v-if="(giveaway.creator_id != $store.state.user_id) && 
								  !giveaway.entered_giveaway && 
								  (giveaway.point <= $store.state.points) &&
								  wlistChecked
								  ">						 
							<button v-if="!enterWait"
									class="btn btn-primary btn-md rounded w-100"
									@click="enterGiveaway()">							
								<font-awesome-icon :icon='["fa", "plus-circle"]' />&nbsp;
								<span>Enter Giveaway ({{giveaway.point}} P)</span>
							</button>
							<loading-button
								v-if="enterWait"
								:loading='enterWait'
								class='nav-link'
							>
								<font-awesome-icon icon="spinner"/>
							</loading-button>
						</div>
						<div class="row text-center mb-3 d-flex justify-content-center"
							v-if="(giveaway.creator_id != $store.state.user_id) && giveaway.entered_giveaway && (giveaway.point <= $store.state.points)">
							<button v-if="!exitWait" 
									class="btn btn-secondary btn-md rounded w-100"
									@click="exitGiveaway()">							
								<font-awesome-icon :icon='["fa", "minus-square"]' />&nbsp;
								<span >Exit Giveaway ({{giveaway.point}} P)</span>
							</button>
							<loading-button
								v-if="exitWait"
								:loading='exitWait'
								class='nav-link text-center'
							>
								<font-awesome-icon icon="spinner"/>
							</loading-button>						
						</div>
					</div>

					<fancy-input
						:placeholder='`${ $t("gifts_search") }...`'
						v-model='searchGiveaway'
						type="text"
						aria-label="Search"
						ref="search"
						:large='true'
						:error='error.search'
					></fancy-input>
					<ul id="filtersList" class="nav accordion d-flex flex-column flex-nowrap bg-gray-900 border border-green-lighter border-top-0  box-shadow my-3">
						<li class="nav-item py-3">
							<div class="d-flex row align-items-center justify-content-between m-0 px-2">
								<div class="categories-title d-flex row align-items-center col-11">
									<p class="h6 text-white mb-0 py-2">Giveaway</p>
								</div>
							</div>
							<!-- >> -->
							<router-link class='threads_main__side_bar__menu_item' to=''>
								<p class="d-flex">
									<span class='threads_main__side_bar__menu_item__border'></span>
									<span class='threads_main__side_bar__menu_item__text'>Comments</span>
								</p>
								<span class='threads_main__side_bar__menu_item__text'>{{ allComments.length }}</span>
							</router-link>
							<router-link class='threads_main__side_bar__menu_item' 
										:to='`/${$store.state.meta.lang}/giveaways/entries/${giveaway.giveaway_id}`'
							>
								<p class="d-flex">
									<span class='threads_main__side_bar__menu_item__border'></span>
									<span class='threads_main__side_bar__menu_item__text'>Entries</span>
								</p>
								<span class='threads_main__side_bar__menu_item__text'>{{ giveaway.entries_cnt }}</span>
							</router-link>
							<!--  -->														
							<router-link v-if="giveaway.winner && giveaway.winner.length" class='threads_main__side_bar__menu_item'
										:to='`/${$store.state.meta.lang}/giveaways/winners/${giveaway.giveaway_id}`'>
								<p class="d-flex">
									<span class='threads_main__side_bar__menu_item__border'></span>
									<span class='threads_main__side_bar__menu_item__text'>Winners</span>
								</p>
								<span class='threads_main__side_bar__menu_item__text'>
									{{ giveaway.winner.length }}
								</span>
							</router-link>
							<a v-else class='threads_main__side_bar__menu_item'>
								<p class="d-flex">
									<span class='threads_main__side_bar__menu_item__border'></span>
									<span class='threads_main__side_bar__menu_item__text'>Winners</span>
								</p>
								<span class='threads_main__side_bar__menu_item__text'>
									None
								</span>
							</a>
							<!-- << -->
						</li>
					</ul>
				</div>
				<div class="col-lg-9 pl-lg-3 px-0 pb-3">
					<h2 class="border-bottom border-green-lighter my-3"> {{ $t('gifts_description') }}</h2>
                    <div class="bg-gray-900 border border-green-lighter mt-3 px-3 py-3">
                        <div class="markdown markdown_description">                            
							{{ giveaway.description }}
                        </div>
                    </div>

					<h4 class="border-bottom border-green-lighter mt-3"> {{ allComments.length }} {{ $t('gifts_comments') }} </h4>
					<div class="comments border border-green-lighter my-3 px-3">
						<div class="comments">							
							<recursive-component v-for="(child, index) in allComments" 
												:comment='child' 
												:key="index"
												@replyTo="replyMe($event)"
												>
							</recursive-component>								
						</div>
						<span v-if="error.parent_id" class="text-danger">*{{ $t('gifts_select_section_answer') }}</span>						
					</div>

					<!-- submit form ==>> -->
					<div v-if="$store.state.username.length" class="comments border border-green-lighter my-3 p-3">
						<div class="row">									
							<div class="col-1 justify-content-center align-items-center m-auto text-center">
								<router-link :to="`/${$store.state.meta.lang}/user/${$store.state.username}`" 
									class="giveaway_image_avatar m-auto" 
									:style="$store.state.profile_photo_path ?
									{ 'background-image': `url(${apiDomain}/uploads/avatar/${$store.state.profile_photo_path})` }:
									{ 'background-image': 'url(' + missed_avatar + ')' }"
								></router-link>
								<router-link :to="`/${$store.state.meta.lang}/user/${$store.state.username}`" >
									{{ $store.state.username }}
								</router-link>
							</div>										
							<div class="col-11">								
								<textarea class="form-control" v-model="content"></textarea>
								<span v-if="error.content" class="text-danger">*{{ $t('gifts_introduce_comment') }}</span>
								<p v-if="!!error.msg" class="text-danger">*{{ error.msg }}</p>
							</div>							
						</div>
						<div class="row">
							<div class="col-1"></div>
							<div class="col-11 mt-4">								
								<button v-if=" submit_comment_type==='save' " class="btn btn-primary btn-md rounded" @click="saveComment">
									<loading-button
										v-if="creationLoading"
										:loading='creationLoading'
										class='nav-link'
									>
										<font-awesome-icon icon="spinner"/>
									</loading-button>										
									<span v-else >
										<span>{{ $t('gifts_add_comment') }}</span>
									</span>
								</button>
								<button v-else class="btn btn-primary btn-md rounded" @click="updateComment">
									<loading-button
										v-if="creationLoading"
										:loading='creationLoading'
										class='nav-link'
									>
										<font-awesome-icon icon="spinner"/>
									</loading-button>										
									<span v-else >
										<span>{{ $t('gifts_update_comment') }}</span>
									</span>
								</button>
							</div>
						</div>
					</div>
					<!-- << -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FancyInput from '../FancyInput'
	import InfoTooltip from '../InfoTooltip.vue'
	import {apiDomain} from '../../config'
	import LoadingButton from '../LoadingButton';
	import ThreadDisplayPlaceholder from '../ThreadDisplayPlaceholder';	
	import RecursiveComponent from '../RecursiveComponent';

	export default {
		name: 'giveaway',
		components: {
			FancyInput,
			LoadingButton,
			InfoTooltip,
			ThreadDisplayPlaceholder,
			RecursiveComponent
		},
		data () {
			return {
				creationLoading: false,
				apiDomain: apiDomain,
				choosed_color: "#00ff7f",
				choosed_back_color: "#00ff7f",
				enterWait: false,
				exitWait: false,
				giveaway: this.$store.state.meta.giveaway,
				parentID: 0,
				content: "",
				submit_comment_type: 'save',
				submit_comment_id: 0,
				allComments:{},				
				storeAllComments:{},
				error: {
					parent_id : false,
					content: false,
					msg: '',
					search: ''
				},
				user: { },
				loading: true,
				categories: [
					{ "name": "Comments", "value": "comments", "count": 9},
					{ "name": "Entries", "value": "entries", "count": 5},
                    { "name": "Winners", "value": "winners", "count": 1}
				],
				searchGiveaway: "",
				missed_avatar: require("./../../assets/img/new-home/missed_avatar.jpg"),
				wlistChecked: false,
			}
		},
		watch: {			
			searchGiveaway: function(sKey){
				
				if(!!sKey){
					this.allComments = this.storeAllComments.filter( x => x.content.toLowerCase().includes(sKey.toLowerCase()) );
				}else{
					this.allComments = this.storeAllComments;
				}

				!this.allComments.length ? (this.error.search = this.$t("gifts_no_results")) : this.error.search = '';
				!sKey && (this.error.search = '');
			},
			'$store.state.meta.giveaway': function(){
				this.giveaway = this.$store.state.meta.giveaway;
			}
		},
		methods: {
			initComments: function(res){	

				// this.drawDiscussion = res.data.content;

				this.storeAllComments 	= res.data.content.all_children;

				this.allComments = this.storeAllComments;
			},
			saveComment: function(e){

				if(!this.content){ this.error.content = true; return false; } 
				if(this.content){ this.error.msg = ""}

				this.creationLoading = true;

				this.axios.post(`${apiDomain}/api/v1/giveawayscomments`,
					{	parent_id: this.parentID, 
						giveaway_id: this.$route.params.id,
						content: this.content
					},
					{ 
						headers: { 'Authorization': `Bearer ${this.$cookies.get('authtoken')}`} 
					}
				).then(res => {
					
					this.creationLoading = false;
					this.content = "";
					this.parent_id = 0;

					if(res.data.response == 'success'){
						this.initComments(res);
					}else{
						this.error.msg = res.data.content;
					}
					
				}).catch(err => {
					
					console.log(err)
					this.$router.push('/');
				})
			},
			removeComment: function(comment_id){
				
				this.creationLoading = true;

				this.axios.request({
                    method: 'delete',
                    url: `${apiDomain}/api/v1/giveawayscomments/${comment_id}`,
                    headers: {
                        'Authorization': `Bearer ${this.$cookies.get('authtoken')}`
                    }
                }).then(res => {
					
					this.creationLoading = false;
					this.content = "";
					this.parent_id = 0;

					if(res.data.response == 'success'){
						this.initComments(res);
					}else{
						this.error.msg = res.data.content;
					}
					
				}).catch(err => {
					
					console.log(err)
					this.$router.push('/');
				})
			},
			updateComment: function(){
				
				
				if(!this.content){ this.error.content = true; return false; } 
				if(this.content){ this.error.msg = ""}
				
				this.creationLoading = true;

				this.axios.put(`${apiDomain}/api/v1/giveawayscomments/${this.submit_comment_id}`,
					{ content: this.content },
					{ headers: { 'Authorization': `Bearer ${this.$cookies.get('authtoken')}`} }
				).then(res => {
					
					this.creationLoading = false;
					this.content = "";
					this.parent_id = 0;

					this.submit_comment_type = 'save';
					this.submit_comment_id = 0;

					if(res.data.response == 'success'){
						this.initComments(res);
					}else{
						this.error.msg = res.data.content;
					}
					
				}).catch(err => {
					
					console.log(err)
					this.$router.push('/');
				})
			},
			replyMe: function(data){
				
				if(data.type == 'remove'){
					this.removeComment(data.cid);
					return;
				}else if(data.type == 'edit'){
					
					this.content = data.content;
					this.submit_comment_type = 'edit';	
					this.submit_comment_id = data.cid;	
				}else{
					this.parentID = data.cid;
				}

				this.error.parent_id = false;
				this.error.msg = "";
				this.error.content = false;			

				// this.$store.commit('setComments', data.cmts);
			},
			getSingelGiveaway: function(token){

				if(!token) this.$router.push('/');

				let giveaway_id = this.$route.params.id;
				let gx = this;
				if(giveaway_id ){
					this.axios.request({
						method: 'GET',
						url: `${apiDomain}/api/v1/giveaway/${giveaway_id}`,
						headers: {
							'Authorization': `Bearer ${token}`
						}
					}).then(res => {
						
						this.$store.commit('setNmessages', res.data.content.message);
						
						if(res.data.content.region.select==='yes' && !res.data.content.region.show){
							this.$router.push('/');
						}else{

							this.$store.commit('setGiveaway', res.data.content);
							
							let tmpContent = res.data.content.whocanenter;
							if( tmpContent.select === "wgroup" ){
								gx.wlistChecked = !!tmpContent.data.filter( x => x.id === gx.$store.state.user_id).length
							}else{
								gx.wlistChecked = true;
							}
						}
						this.loading = false;
	
					}).catch(err => {
						console.log(err);
						this.$router.push('/');
					})
				}
				
			},

			enterGiveaway: function(){
				this.enterWait = true
				this.axios.post(`${apiDomain}/api/v1/giveaway/enter`, 
					{
						user_id: this.$store.state.user_id,
						giveaway_id: this.$route.params.id
					},
					{
						headers: { 'Authorization': `Bearer ${this.$cookies.get('authtoken')}`}
					}
				).then(res => {
					this.enterWait = false;
					if(res.data.data.result){
						this.exitWait = false;
						this.$store.commit('setGiveaway', res.data.data.giveaway);
						this.$store.commit('setPoints', res.data.data.user_points);
					}else{
						this.$router.push('/');	
					}
					
				}).catch(err => {
					console.log(err)
					this.$router.push('/');
				})
			},

			exitGiveaway: function(){
				this.exitWait = true
				this.axios.post(`${apiDomain}/api/v1/giveaway/exit`, 
					{
						user_id: this.$store.state.user_id,
						giveaway_id: this.$route.params.id
					},
					{
						headers: { 'Authorization': `Bearer ${this.$cookies.get('authtoken')}`}
					}
				).then(res => {
					this.exitWait = false;
					if(res.data.data.result){
						this.enterWait = false;
						this.$store.commit('setGiveaway', res.data.data.giveaway);
						this.$store.commit('setPoints', res.data.data.user_points);
					}else{
						this.$router.push('/');	
					}
					
				}).catch(err => {
					console.log(err)
					this.$router.push('/');
				})
			},

		},
		mounted() {
			let token = this.$cookies.get('authtoken');

			//Get the giveaway
			this.getSingelGiveaway(token);
			
			//Get the comments for giveaway
			let giveaway_id = this.$route.params.id;
			if(giveaway_id && !!token){
				this.axios.request({
					method: 'GET',
					url: `${apiDomain}/api/v1/giveaway/comments/${giveaway_id}`,
					headers: {
						'Authorization': `Bearer ${token}`
					}
				}).then(res => {
					
					this.initComments(res);
				}).catch(err => {
					console.log(err);
					// this.$router.push('/');
				})
			}
		}		
	}
</script>

<style lang='scss' scoped>
	@import '../../assets/scss/elementStyles.scss';
	@import '../../assets/scss/variables.scss';
	@import '../../assets/scss/idec.scss';

	.hero_section{
		display: flex;
		justify-content: center; 
		align-items: center;

		@at-root #{&}__img_link {
			margin-right: 25px;
			background-color: rgba(0,0,0,0.2);
			border-left-color: transparent;
			border-top-color: transparent;
			box-shadow: 3px 3px 4px #0000002e;
			padding: 10px;

			img{
				width: 100%;
				max-width: 500px;
				max-height: 215px;
			}
		}

		@at-root #{&}__summary {
			flex: 1;

			.summary_columns{
				display: flex;

				.summary__column{
					min-height: 26px;
					white-space: nowrap;
					color: rgba(255,255,255,0.6);
					border-radius: 4px;
					font-size: 11px;
					border: 1px solid rgba(255,255,255,0.1);
					line-height: 26px;
					padding: 0 8px;

					&:nth-child(2){
						flex: 1;
						margin-left: 0.5rem;
						margin-right: 0.5rem;
					}
				}

                .giveaway__columns{
                    &__contributor-level{
                        border-color: #f0d0d3 #e5bbbc #daa9a8 #ebbfc0 !important;
                        color: rgba(166,93,92,0.95) !important;
                        background-image: -webkit-linear-gradient(#f5eaec 0%, #e6d9de 100%) !important;
                        white-space: nowrap;
                        border-radius: 4px;
                        font-size: 11px;
                        border: 1px solid #d2d6e0;
                        line-height: 30px;
                        padding: 0 8px;
                        margin-right: 0.5rem;
                    }
                }
			}
		}
	}

    .markdown_description p{
        margin-bottom: 1rem;
    }

	.router-link-exact-active span:first-child {
		background-color: $color__green--primary;
	}

	.router-link-exact-active span:last-child {
		color: $color__green--primary;
	}

	.threads_main {
		display: flex;

		&__side_bar{
			width: 12rem;
			height: 0%;
			background: #fff;
			margin-right: 1rem;
			border-radius: 0.25rem;
			border: thin solid $color__gray--darker;
			padding: 0.5rem 0 1rem 1rem;
			position: sticky;
			top: 4.5rem;

			@at-root #{&}__title {
				color: $color__darkgray--darker;
				cursor: default;
				font-weight: 500;
				font-size: 1.125rem;
			}

			@at-root #{&}__menu_item {
			    cursor: pointer;
				margin-top: 0.5rem;
				position: relative;
				display: flex;
				justify-content: space-between;
				grid-template-columns: 0.75rem auto;
				grid-column-gap: 1rem;
				text-decoration: none;
				background-image: none;
				font-weight: normal;
				margin-left: 1.5rem;
				margin-right: 1.5rem;

				span{
					color: #fff;
				}

				@at-root #{&}__border {
					align-self: center;
					display: inline-block;
					height: 0.9rem;
					width: 0.9rem;
					border-radius: 0.5rem;
					background-color: $color__gray--darkest;
					transition: all 0.2s;
                    margin-right: 5px;
                    margin-top: -1px;
				}

				@at-root #{&}__text {
					filter: saturate(0.75), brightness(0.75);
				}


				@at-root #{&}--selected {
					font-weight: 600;
				}
			}
		}

		&__load_new{
			@extend .button;

			font-size: 1.25rem;
			margin: 0 0 1rem 0;
			background-color: $color__lightgray--primary;
			border-color: $color__gray--darker;
			width: 100%;
			font-weight: 300;
		}
	}

    .comments{
		.comment{
			margin: 1rem 0;
			border-bottom: 1px solid $color__gray--darker;

			&:last-child{
				border-bottom: none;
			}

			&__parent, &__child, &__entity{
				max-width: 850px;
				display: flex;
			}

			&__children{
				margin-left: 50px;
			}

			.global__image-outer-wrap--avatar-small{
				height: 32px;
				width: 32px;
			}

			&__child{
				border: 1px solid $color__lightgray--primary;
				border-radius: 4px;
				padding: 15px;
			}

			&__actions{
				display: flex;
			}

			.global__image-outer-wrap--avatar-small{
				margin-right: 10px;
			}

			&__children:not(.comment__children--no-indent){
				padding-left: 25px;
				border-left: 1px solid #d2d6e0;
			}

			.giveaway_image_avatar{
				margin-right: 1rem;
			}

			&__summary{
                padding-bottom: 0.5rem;

				.comment__author{
					color: $color__green--primary;
					margin-bottom: 5px;
					display: flex;

					svg{
						margin-top: -1px;
						margin-right: 0.5rem;

						&:focus, &:hover{
							cursor: pointer;
							outline: none;
						}
					}
				}
			}
			.nav__avatar-inner-wrap, .global__image-inner-wrap{
				background-position: center center;
				background-repeat: no-repeat;
				background-size: cover;
				height: 100%;
				width: 100%;
				border-radius: 2px;
			}
		}
	}

    .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }

	@media (max-width: $breakpoint--tablet) {
		.hero_section{
			display: block;
			text-align: center;
		}
	}
</style>
<style>
	.img-container-initComments{
		min-width: 430px;
		min-height: 215px;
	}
</style>

